import docReady from '../../../assets/js/docReady';
import { logAnalyticsEvent } from "../../../assets/js/helpers/bananas";

docReady(() => {
    const expandCards = document.querySelectorAll('[data-expand-card]');
    const handleInteraction = (e, card) => {
        if (e.target.tagName === 'A') {
            return;
        }
        if (e.type === 'click' || (e.type === 'keydown' && (e.key === 'Enter' || e.key === ' '))) {
            if (e.type === 'keydown') {
                e.preventDefault();
            }
            toggleCard(card);
        }
    };

    const toggleCard = (card) => {
        const isExpanded = card.getAttribute('data-expanded') === 'true';

        card.setAttribute('data-expanded', !isExpanded);
        card.setAttribute('aria-expanded', !isExpanded);
        
        if (!isExpanded) {
            card.scrollIntoView({
                behavior: 'smooth',
                block: 'start',

            });

            logAnalyticsEvent('steplistTextAndVisual.open-card', {
                card_id: card.getAttribute('aria-controls'),
            });

        }
    };


    expandCards.forEach(card => {
        if (card.classList.contains('strapped')) {
            return;
        }

        card.classList.add('strapped');

        card.addEventListener('click', (e) => handleInteraction(e, card));
        card.addEventListener('keydown', (e) => handleInteraction(e, card));
    });
});
